import {Component, OnInit, TemplateRef} from '@angular/core';
import {TaskOptionsService} from '../../../../services/task-options.service';
import {TaskTypesModel} from '../../../../models/tasktable.model';
import {AlertService} from '../../../../services/notify/alert.service';
import {CrmService} from '../../../../services/api/crm.service';
import {TaskServiceService} from '../../../../services/task-service.service';
import {ModalService} from '../../../../services/modal/modal.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-task-types',
    templateUrl: './task-types.component.html',
    styleUrls: ['./task-types.component.scss']
})
export class TaskTypesComponent implements OnInit {
    isShowIcons = false;
    selectType: TaskTypesModel;
    selectedType: TaskTypesModel;
    boardTypes: TaskTypesModel[] = [];
    svgIcons = {
        selectedSvg: '',
        allSvg: [
            'bi bi-alarm',
            'bi bi-archive',
            'bi bi-at',
            'bi bi-asterisk',
            'bi bi-bar-chart',
            'bi bi-bar-chart-steps',
            'bi bi-bell',
            'bi bi-box-seam',
            'bi bi-bricks',
            'bi bi-briefcase',
            'bi bi-buildings',
            'bi bi-calendar-date',
            'bi bi-camera',
            'bi bi-cash-stack',
            'bi bi-chat-dots',
            'bi bi-check2-all',
            'bi bi-easel',
            'bi bi-pen',
            'bi bi-airplane',
            'bi bi-bank',
            'bi bi-basket',
            'bi bi-book',
            'bi bi-car-front',
            'bi bi-card-image',
            'bi bi-clock',
            'bi bi-currency-exchange',
            'bi bi-database',
            'bi bi-envelope-open',
            'bi bi-exclamation-octagon',
            'bi bi-inboxes',
            'bi bi-info-square',
            'bi bi-lightning-charge',
            'bi bi-lock',
            'bi bi-megaphone',
            'bi bi-pin',
            'bi bi-pin-map'
        ]
    };

    isLockButton = false;

    constructor(
        public taskOptionsService: TaskOptionsService,
        public alert: AlertService,
        public crmService: CrmService,
        public taskService: TaskServiceService,
        protected modelService: ModalService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
    }

    onOpenModal(content: TemplateRef<any>): void {
        this.modelService.openTemplateModal(content);
    }

    onOpenDeleteModal(type, content): void {
        this.selectedType = type;
        this.boardTypes = this.taskOptionsService.selectedBoard.task_types.filter(x => x.id !== type.id);
        this.onOpenModal(content);
    }

    createTaskType(title, modal: NgbModalRef): void {
        if (!title) {
            return this.alert.setAlert(this.translate.instant('ALERTS.SET_NAME'), 'blue');
        }
        if (!this.svgIcons.selectedSvg) {
            return this.alert.setAlert(this.translate.instant('ALERTS.SET_ICON'), 'blue');
        }

        const data = {
            board_alias: this.taskOptionsService.selectedBoard.alias,
            name: title,
            icon: this.svgIcons.selectedSvg
        };

        this.isLockButton = true;

        this.crmService.createTaskType(data).subscribe({
            next: () => {
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                modal.close();
                this.svgIcons.selectedSvg = '';
                this.isShowIcons = false;
                this.taskService.getBoard(this.taskOptionsService.selectedBoard.alias, true).then(res => {
                    this.taskOptionsService.selectedBoard = res.board;
                });
                this.isLockButton = false;
            }, error: () => {
                this.isLockButton = false;
                this.alert.setAlert(this.translate.instant('ALERTS.ERROR'), 'blue');
            }
        });
    }

    updateTaskType(modal: NgbModalRef): void {
        const data = {
            name: this.selectType.name,
            icon: this.selectType.icon
        };

        this.isLockButton = true;
        this.crmService.updateTaskType(this.selectType.id, data).subscribe({
            next: () => {
                this.isLockButton = false;
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                modal.close();
                this.taskService.getBoard(this.taskOptionsService.selectedBoard.alias, true).then(res => {
                    this.taskOptionsService.selectedBoard = res.board;
                });
            }, error: error => {
                this.isLockButton = false;
                this.alert.setAlert(error.message, 'blue');
            }
        });
    }

    deleteTaskType(typeId, modal: NgbModalRef): void {
        if (!typeId) {
            return this.alert.setAlert(this.translate.instant('ALERTS.DELETE_TASK_TYPE'), 'blue');
        }

        this.isLockButton = true;
        this.crmService.deleteTaskType(this.selectedType.id, typeId).subscribe({
            next: res => {
                this.alert.setAlert(res.message, 'green');
                modal.close();
                this.selectType = null;
                this.taskService.getBoard(this.taskOptionsService.selectedBoard.alias, true).then(result => {
                    this.taskOptionsService.selectedBoard = result.board;
                });
                this.isLockButton = false;
            }, error: error => {
                this.isLockButton = false;
                this.alert.setAlert(error.message, 'blue');
            }
        });
    }
}
